import { CAPTION_CLASS } from '../financial.type.component';

const REQUIRED_LABEL = 'Motivo da exceção';
const OPTIONAL_LABEL = 'Observação, se quiser complementar';

const REQUIRED_HINT = 'Obrigatório: por que a empresa vai pagar mais do que recebe neste serviço.';
const OPTIONAL_HINT = 'Se houver algo que os itens não expliquem, escreva aqui.';

export default function AdjustmentReasonField({ reason, onChange, isRequired }) {

    return (
        <div className="mt-4">
            <label className={CAPTION_CLASS} htmlFor="adjustment-reason">
                {isRequired ? REQUIRED_LABEL : OPTIONAL_LABEL}
            </label>
            <textarea
                id="adjustment-reason"
                value={reason}
                onChange={(event) => onChange(event.target.value)}
                rows={2}
                placeholder={isRequired ? REQUIRED_HINT : OPTIONAL_HINT}
                className="mt-2 w-full text-sm rounded-xl border border-[#e5e5e5] p-3 outline-none focus:border-[#376fd0]"
            />
        </div>
    );
}
